<template>
  <div class="card" v-show="currentCardId == 'resume-list'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>同封書類</h2>
        <p>同封書類を入力しましょう</p>
      </div>
      <div class="card-content">
        <el-input
          type="textarea"
          v-model="formatData.resumeSummary"
          :autosize="{ minRows: 5, maxRows: 15 }"
        />
        <div
          class="attention-limit character"
          v-if="previewErrors.resumeSummary"
        >
          <i class="el-icon-warning"></i>
          入力可能な文字数をオーバーしています。文章を短くしてください。
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLetterFormatData } from '@/composables/format-edit/useLetterFormatData'

defineProps<{
  currentCardId?: string
  previewErrors: Record<string, string | undefined>
}>()

const formatData = useLetterFormatData()
</script>
